import { render, staticRenderFns } from "./LandingPromoCodes.vue?vue&type=template&id=2987da3f&scoped=true&"
import script from "./LandingPromoCodes.vue?vue&type=script&lang=js&"
export * from "./LandingPromoCodes.vue?vue&type=script&lang=js&"
import style0 from "./LandingPromoCodes.vue?vue&type=style&index=0&id=2987da3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2987da3f",
  null
  
)

export default component.exports